import React, { createContext, PropsWithChildren, useCallback, useRef, useState } from 'react';
import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogProps,
    DialogTitle,
} from '@material-ui/core';

export interface ConfirmOptions {
    title?: string;
    description?: string;
    dialogProps?: DialogProps;
}

export const ConfirmContext = createContext((_: ConfirmOptions) => Promise.resolve());

const Provider = (props: PropsWithChildren<any>) => {
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [open, setOpen] = useState(false);
    const [dialogProps, setDialogProps] = useState({});
    const handleClose = useCallback(() => {
        setOpen(false);
        rejectRef.current();
    }, []);
    const resolveRef = useRef(() => {});
    const rejectRef = useRef(() => {});
    const confirm = (options: ConfirmOptions) => {
        setTitle(options.title || 'Вы уверены?');
        setDescription(options.description || '');
        setDialogProps(options.dialogProps || {});
        setOpen(true);
        return new Promise<void>((resolve, reject) => {
            resolveRef.current = resolve;
            rejectRef.current = reject;
        });
    };

    const handleOk = useCallback(() => {
        resolveRef.current();
        setOpen(false);
    }, []);

    return (
        <ConfirmContext.Provider value={confirm}>
            <Dialog open={open} fullWidth={true} {...dialogProps}>
                <DialogTitle>{title}</DialogTitle>
                <DialogContent>{description}</DialogContent>
                <DialogActions>
                    <Button onClick={handleClose} color="primary">
                        Нет
                    </Button>
                    <Button onClick={handleOk} color="primary" autoFocus>
                        Да
                    </Button>
                </DialogActions>
            </Dialog>
            {props.children}
        </ConfirmContext.Provider>
    );
};

export default Provider;
